module.exports = __webpack_public_path__ + "img/pos2-bg.83e7e9e3.jpg";